<div *ngIf="!userPhoto">
    <svg [attr.height]="height + 'px'" [attr.width]="width + 'px'" xmlns="http://www.w3.org/2000/svg"
         [matTooltip]="user.firstName + ' ' + user.lastName">
        <g>
            <title>background</title>
            <rect fill="#fff" fill-opacity="0" id="canvas_background" [attr.height]="(height/2) + 'px'"
                  [attr.width]="(width/2) + 'px'"/>
        </g>
        <g fxFlex fxLayoutAlign="center center">
            <ellipse stroke="#005fbf" [attr.ry]="(height/2) + 'px'" [attr.rx]="(width/2) + 'px'"
                     [attr.cy]="(height/2) + 'px'" [attr.cx]="(width/2) + 'px'" id="svg_1"
            stroke-width="1.5" fill="#005fbf"/>
            <text stroke="#005fbf"
                  xml:space="preserve" text-anchor="middle" dominant-baseline="middle"
                  font-family="Helvetica, Arial, sans-serif"
                  [attr.font-size]="fontSize"
                  id="svg_5" x="50%" y="50%" stroke-width="0"
                  fill="#ffffff">{{firstLetter + secondLetter}}</text>
            <image *ngIf="loading" href="assets/images/thumbs/spin_loading.svg" [attr.width]="width" ></image>
        </g>
    </svg>
</div>
<div *ngIf="userPhoto && !loading" [matTooltip]="user.firstName + ' ' + user.lastName">
    <img src="{{userPhoto}}" [width]="width" class="user-photo m-0" alt="Foto Usuário">
</div>